<glxy-hint>
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CUSTOMER_VIEWS_PACKAGE.CUSTOMER_INTERESTED_IN_PACKAGE_HINT' | translate }}</glxy-hint
>

<div>
  <div>
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CUSTOMER_VIEWS_PACKAGE.CUSTOMER_INTERESTED_IN_PACKAGE_ORIGIN' | translate }}:
  </div>
  <automata-automations-interest-origin-selector
    [partnerId]="automation.namespace"
    [marketId]="automation.marketId"
    (interestOriginSelection)="handleInterestOriginSelection($event)"
  ></automata-automations-interest-origin-selector>
</div>

<div class="package-selector-container">
  <div>
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CUSTOMER_VIEWS_PACKAGE.CUSTOMER_INTERESTED_IN_PACKAGE_SELECTION' | translate }}:
  </div>
  <automata-automation-replacement-chips
    *ngIf="!automation.isTemplate"
    label="AUTOMATIONS.EDITOR.FILTERS.OPPORTUNITY_DATA.DATA_LABELS.PACKAGES"
    [dataService]="service"
    [formControl]="control"
    [isRequired]="true"
    [multiple]="false"
    [supportDataPassing]="false"
    [extraData]="{ includeAny: true }"
    (finishedInitialLoading)="finishedLoading()"
  ></automata-automation-replacement-chips>
</div>
